export const AddressTypes = [
  { key: "wrokPlace", value: "محل فعالیت" },
  { key: "sendBill", value: "ارسال صورت حساب" },
  { key: "sendGood", value: "ارسال کالا" },
  { key: "warehouse", value: "انبار" },
  { key: "home", value: "منزل" },
  { key: "official", value: "رسمی" },
  { key: "postal", value: "پستی" },
  { key: "others", value: "سایر" },
];
